import type { AnalysisState } from '@aibi/contracts';
import type { FieldDescriptor } from '../../model/field-catalog';
import { FieldItem } from './FieldItem';
import { ExplorerSection } from './ExplorerSection';

export interface FieldListProps {
  readonly title: string;
  readonly fields: readonly FieldDescriptor[];
  readonly selectedCard: AnalysisState | null;
  readonly onAdd: (field: FieldDescriptor) => void;
  /** Quita de la visualizacion seleccionada el campo con esa clave local. */
  readonly onRemove: (key: string) => void;
  readonly emptyText: string;
}

/** Lista generica de campos con encabezado y contador. */
export function FieldList({
  title,
  fields,
  selectedCard,
  onAdd,
  onRemove,
  emptyText,
}: FieldListProps) {
  const keyInUse = (field: FieldDescriptor): string | undefined =>
    selectedCard === null
      ? undefined
      : field.kind === 'dimension'
        ? selectedCard.dimensions.find((d) => d.dimensionId === field.id)?.key
        : selectedCard.measures.find((m) => m.measureId === field.id)?.key;

  return (
    <ExplorerSection title={title} count={fields.length}>
      {fields.length === 0 ? (
        <p className="px-2 py-1 text-xs text-muted-foreground">{emptyText}</p>
      ) : (
        <ul aria-label={title} className="space-y-px">
          {fields.map((field) => {
            const key = keyInUse(field);
            return (
              <FieldItem
                key={field.id}
                field={field}
                inUse={key !== undefined}
                onAdd={onAdd}
                onRemove={() => {
                  if (key !== undefined) onRemove(key);
                }}
              />
            );
          })}
        </ul>
      )}
    </ExplorerSection>
  );
}

type KindListProps = Omit<FieldListProps, 'title' | 'emptyText'>;

export function DimensionList(props: KindListProps) {
  return <FieldList title="Dimensiones" emptyText="Sin dimensiones que coincidan." {...props} />;
}

export function MeasureList(props: KindListProps) {
  return <FieldList title="Medidas" emptyText="Sin medidas que coincidan." {...props} />;
}
